import { createParser } from "eventsource-parser";
import http from "../utils/request";
import { mergeSignals } from "@/utils";

const apiKey = "app-Ar4lX3qQwrwU8m6mAyga14q8";

// 大模型参数，默认东方大模型
function getOptions(msg, conversation_id = "") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${apiKey}`,
    },
    body: JSON.stringify({
      files: [],
      inputs: {},
      query: msg,
      conversation_id,
      response_mode: "streaming",
      user: "abc-123",
    }),
  };
}

async function* streamAsyncIterable(reader) {
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        return;
      }
      yield value;
    }
  } finally {
    reader.releaseLock();
  }
}

// 问答
export async function fetchStream({ conversation_id, msg, onMessage, onError, abortController }) {
  console.log(onError);
  // const url = "http://121.40.176.101:39888/v1/chat-messages";
  const url = "/askModel/v1/chat-messages";
  // const url = "https://aistore-business.talkinggenie.com/di-llm/di/api/v1/conversation/message";
  const controller = new AbortController();

  let connectTimeoutId = null;
  let readTimeoutId = null;

  const startConnectTimeout = () => {
    clearTimeout(connectTimeoutId);
    connectTimeoutId = setTimeout(() => {
      controller.abort("连接超时！");
    }, 60 * 1000); // ✅ 连接超时 60s
  };

  const startReadTimeout = () => {
    clearTimeout(readTimeoutId);
    readTimeoutId = setTimeout(() => {
      controller.abort("读取超时！");
    }, 120 * 1000); // ✅ 读取超时 120s
    // console.warn("[fetchStream] read timeout 120s");
  };
  try {
    startConnectTimeout();
    const resp = await fetch(url, {
      ...getOptions(msg, conversation_id),
      signal: mergeSignals([controller.signal, abortController.signal]),
    });
    clearTimeout(connectTimeoutId);
    const reader = resp.body.getReader();
    const textDecoder = new TextDecoder("utf-8");
    const parser = createParser((event) => {
      onMessage(JSON.parse(event.data));
    });
    startReadTimeout();
    try {
      for await (const chunk of streamAsyncIterable(reader)) {
        startReadTimeout();
        const jsonString = textDecoder.decode(chunk);
        try {
          const data = JSON.parse(jsonString);
          if (data.code === 500 || data.code === 408) {
            onError({ msg: "请求出错！" });
            // controller.abort();
          } else {
            parser.feed(jsonString);
          }
        } catch (err) {
          parser.feed(jsonString);
        }
      }
    } finally {
      reader.releaseLock();
    }
  } catch (err) {
    if (err.name === "AbortError") {
      // console.dir(err);
      onError({ msg: "请求超时" });
    } else {
      onError(err);
    }
  } finally {
    clearTimeout(connectTimeoutId);
    clearTimeout(readTimeoutId);
  }
}

export function ttsRes(text, recordId) {
  return http({
    url: "/tts/di-llm/sk/api/v1/conversation/async/tts",
    method: "post",
    data: {
      tts: {
        text,
      },
      context: {
        recordId,
      },
    },
  });
}
